<template>
  <div class="box">
    <div class="tab-content">
      <el-button
        type="text"
        icon="el-icon-circle-plus-outline"
        title="添加报告组"
        @click="createReportGroup"
        class="bottomBox"
        >添加报告组</el-button
      >
      <el-tabs
        tab-position="left"
        style="height: 500px; display: inline"
        @tab-click="tabclick"
        :stretch="true"
        class="tabs"
        v-model="activeName"
      >
        <el-tab-pane
          v-for="(item, i) in list"
          :key="i"
          :label="item.name"
          :name="'' + item.name"
        >
          <span slot="label">
            <i
              class="el-icon-menu"
              style="font-size: 40px; margin: 6% 30% 10% 32%"
            ></i>
            <br />
            {{ item.name }}
            <el-button
              type="text"
              icon="el-icon-edit"
              title="修改"
              @click.stop="modifyReportGroup(item)"
            ></el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              title="删除"
              @click="deleteReportGroup(item)"
            ></el-button>
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="list-content">
      <el-button
        type="text"
        icon="el-icon-circle-plus-outline"
        title="添加报告任务列表"
        @click="addReport"
        class="bottomBox"
        >添加报告任务列表</el-button
      >
      <div class="tabdownload" v-for="(item, index) in download" :key="index">
        <label
          :class="btn == index ? 'btnclick' : 'btn'"
          @click="clickdownload(item, index)"
          >{{ item.baseName }}</label
        >
        <el-button
          type="text"
          icon="el-icon-delete"
          title="删除"
          @click.stop="deleteReport(item)"
        ></el-button>
      </div>
    </div>
    <div class="pdf-content" v-if="startId == '1' ? true : false">
      <energy-saving-space
        :reportData="reportData"
        @savePageAllData="savePageAllData"
      ></energy-saving-space>
    </div>
    <div class="pdf-content" v-if="startId == '2' ? true : false">
      <energy-cost-analysis
        :reportData="reportData"
        @savePageAllData="savePageAllData"
      ></energy-cost-analysis>
    </div>
    <div class="pdf-content" v-if="startId == '3' ? true : false">
      <medical-report
        :reportData="reportData"
        @savePageAllData="savePageAllData"
      ></medical-report>
    </div>
    <!-- 新增报告组 -->
    <el-dialog
      :title="reportTitle"
      :visible.sync="showReport"
      :close-on-click-modal="false"
      width="600px"
      style="text-align: left"
      v-if="showReport"
      @close="formClose"
    >
      <el-form
        label-width="150px"
        :model="reportForm"
        :rules="rules"
        ref="reportForm"
      >
        <el-form-item label="名称:" prop="name" style="margin-bottom: 40px">
          <el-input
            v-model="reportForm.name"
            placeholder="请输入"
            autocomplete="off"
            clearable
            class="itemWidth"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="显示名称:" prop="displayName" style="margin-bottom: 40px;">
                        <el-input v-model="reportForm.displayName" placeholder="请输入" autocomplete="off" clearable  class="itemWidth"></el-input>
                    </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveReportGroup">确 定</el-button>
        <el-button @click="showReport = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增报告任务列表 -->
    <el-dialog
      title="新增报告任务列表"
      :visible.sync="reportTask"
      :close-on-click-modal="false"
      width="600px"
      style="text-align: left"
    >
      <el-form label-width="150px" :model="reportTaskForm">
        <el-form-item label="基础名称:">
          <el-input
            v-model="reportTaskForm.baseName"
            placeholder="请输入"
            autocomplete="off"
            clearable
            class="itemWidth"
          ></el-input>
        </el-form-item>
        <el-form-item label="模型:">
          <el-select
            v-model="reportTaskForm.model"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(item, index) in modelData"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveReport">确 定</el-button>
        <el-button @click="reportTask = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import energySavingSpace from "@/components/page/report/energySavingSpace.vue";
import energyCostAnalysis from "@/components/page/report/energyCostAnalysis.vue";
import medicalReport from "@/components/page/report/medicalReport.vue";
export default {
  components: { energySavingSpace, energyCostAnalysis, medicalReport },
  data() {
    var checkName = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("名称不能为空"));
      } else {
      //   const reg = /[\da-zA-Z_]+/;
      //   if (reg.test(value)) {
      //     callback();
      //   } else {
      //     return callback(new Error("请输入字母,下划线或数字"));
      //   }
      }
    };
    return {
      activeName: "",
      download: [],
      startId: "1",
      list: [],
      data: null,
      downLoadName: "",
      btn: 0,
      reportData: {},
      rules: {
        //弹窗的表单验证功能
        name: [
          {
            // required: true, message: '请输入名称', trigger: ['blur', 'change']
            validator: checkName,
            trigger: ["blur", "change"],
            required: true,
          },
        ],
        displayName: [
          {
            required: true,
            message: "请输入计量点集合",
            trigger: ["blur", "change"],
          },
        ],
      },
      reportTask: false,
      reportTaskForm: {
        baseName: "",
        model: "",
      },
      modelData: [
        {
          id: 2,
          name: "节能空间分析报告",
        },
        {
          id: 3,
          name: "用能成本分析报告",
        },
        {
          id: 4,
          name: "用能体检分析报告",
        },
      ],
      reportTask: false,
      groupId: null,
      groups: [],
      reportTitle: "新增报告组",
      showReport: false,
      reportForm: {
        name: "",
        displayName: "",
      },
    };
  },
  created() {
    this.getReportGroups();
  },
  mounted() {},
  methods: {
    /* 查询报告组 */
    getReportGroups() {
      let vm = this;
      vm.$api.nhtj
        .getReportGroups(vm.$store.state.user.currentCompanyId || "0")
        .then((res) => {
          vm.list = res.data;
          vm.groups = [res.data[0].id];
          // res.data.forEach(item=>{
          //     vm.groups.push(item.id)
          // })
          if (res.data.length > 0) {
            vm.activeName = vm.list[0].name;
            vm.groupId = vm.list[0].id;
            vm.getReportAutomaticGeneratingConfigs();
          }
        });
    },
    /* 新增报告组 */
    createReportGroup() {
      this.reportTitle = "新增报告组";
      this.reportForm = {
        name: "",
        displayName: "",
      };
      this.showReport = true;
    },
    /* 修改报告组 */
    modifyReportGroup(item) {
      this.showReport = true;
      this.reportTitle = "编辑报告组";
      this.reportForm = JSON.parse(JSON.stringify(item));
    },
    /* 关闭验证 */
    formClose() {
      this.$refs["reportForm"].resetFields();
    },
    async saveReportGroup() {
      // nhtj.createReportGroup
      let vm = this;
      if (vm.reportTitle == "新增报告组") {
        let res = await vm.$api.nhtj.createReportGroup(
          vm.$store.state.user.currentCompanyId || "0",
          vm.reportForm.name
          // vm.reportForm.displayName
        );
        if (res.success) {
          vm.getReportGroups();
          vm.showReport = false;
        }
      } else {
        let res = await vm.$api.nhtj.modifyReportGroup(
          vm.reportForm.id,
          vm.reportForm.name
          //   vm.reportForm.displayName
        );
        if (res.success) {
          vm.getReportGroups();
          this.$message.success("修改成功");
          vm.showReport = false;
        }
      }
    },
    /* 删除报告组 */
    deleteReportGroup(item) {
      let vm = this;
      vm.$confirm("是否删除该报告组", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.$api.nhtj.deleteReportGroup(item.id).then((res) => {
          if (res.success) {
            vm.getReportGroups();
          }
        });
      });
    },
    /* 点击报告组 */
    tabclick(e) {
      let item = this.list.find((obj) => obj.name === e.name);
      this.activeName = item.name;
      this.groupId = item.id;
      this.groups = [item.id];
      if (item.name.toString().indexOf("节能空间分析报告") >= 0) {
        this.startId = "1";
      } else if (item.name.toString().indexOf("用能成本分析报告") >= 0) {
        this.startId = "2";
      } else if (item.name.toString().indexOf("用能体检分析报告") >= 0) {
        this.startId = "3";
      }
      this.getReportAutomaticGeneratingConfigs();
    },
    /* 删除报告组 */
    /* 点击报告任务任务 */
    clickdownload(e, a) {
      this.btn = a;
      if (e.model == "2") {
        this.startId = "1";
      } else if (e.model == "3") {
        this.startId = "2";
      } else if (e.model == "4") {
        this.startId = "3";
      }
      this.$nextTick(() => {
        e.groupId = this.groupId;
        this.reportData = e;
      });
    },
    /* 添加报告任务列表 */
    addReport() {
      this.reportTask = true;
      this.reportTaskForm = {
        baseName: "",
        model: "",
      };
    },
    /* 保存新增报告任务列表 */
    async saveReport() {
      let vm = this;
      let res = await vm.$api.nhtj.addReportAutomaticGeneratingConfig(
        vm.$store.state.user.info.companyId || "0",
        vm.reportTaskForm.model,
        vm.reportTaskForm.baseName,
        JSON.stringify({}),
        "3", //循环规则。0不循环，1时，2日，3月,4季度
        "",
        "",
        vm.groupId
      );
      if (res.success) {
        vm.$message.success("保存成功");
        vm.getReportAutomaticGeneratingConfigs();
        vm.reportTask = false;
      }
    },
    /* 删除报告任务列表 */
    deleteReport(item) {
      let vm = this;
      vm.$confirm("是否删除该报告任务器", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.$api.nhtj
          .deleteReportAutomaticGeneratingConfig(item.id)
          .then((res) => {
            if (res.success) {
              vm.getReportAutomaticGeneratingConfigs();
            }
          });
      });
    },
    /* 保存成功 */
    savePageAllData(type) {
      if (type == true) {
        this.getReportAutomaticGeneratingConfigs();
      }
    },
    /* 获取报告列表参数数据 */
    getReportAutomaticGeneratingConfigs() {
      let vm = this;
      vm.$api.nhtj
        .getReportAutomaticGeneratingConfigs(
          vm.$store.state.user.currentCompanyId || "0",
          vm.groups
        )
        .then((resOne) => {
          if (resOne.data.length > 0) {
            vm.download = resOne.data;
            if (resOne.data[vm.btn]) {
              vm.clickdownload(resOne.data[vm.btn], vm.btn);
            } else {
              vm.btn = 0;
              vm.clickdownload(resOne.data[vm.btn], vm.btn);
            }
          } else {
            vm.download = [];
            vm.startId = "-1";
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 20px 0px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
}
.tab-content {
  flex: 0 0 162px;
}
.pdf-content {
  flex: 1;
  padding: 0px 10px;
  text-align: left;
}
.list-content {
  //   flex: 1;
  flex: -1 0 300px;
  width: 300px;
  border-right: 2px solid #e4e7ed;
  overflow-y: auto;
}
.tabdownload {
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  // border-bottom: 1px solid #e4e7ed;
  padding: 10px;
}
.btn {
  flex: 1;
  display: block;
  cursor: pointer;
}
.btnclick {
  flex: 1;
  display: block;
  cursor: pointer;
  color: #409eff;
  border-bottom: 2px solid #409eff;
  height: 40px;
}
.itemWidth {
  width: 220px;
}
.btn-download:hover {
  cursor: pointer;
  color: #409eff;
}
</style>
<style lang="scss">
.tabs {
  .el-tabs__item {
    height: 100px !important;
  }
}
.bottomBox {
  text-align: left;
  border: 1px solid #ccc;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
